<script lang="ts" setup>
defineOptions({
  name: 'OpenGeneralCard',
});

const {
  title,
} = defineProps<{
  title?: string;
}>();
</script>

<template>
  <ACard class="open-general-card" :title="`${title === '' ? '' : (title || $route.meta.title)}`">
    <slot></slot>
  </ACard>
</template>

<style lang="scss" scoped>
.open-general-card {
  border: none;
  border-radius: 4px;

  :deep() {
    & > .arco-card-header {
      height: auto;
      padding: 20px;
      border: none;
    }

    & > .arco-card-body {
      padding: 0 20px 20px 20px;
    }
  }
}
</style>
